import React from 'react';

const TableWithActions = (props) => {
  const { headers, data, rowKey, setAction } = { ...props };

  const createRowKey = (row, key) => {
    if (typeof key === 'string') {
      return `${row[key]}-tr`;
    }
    if (Array.isArray(key)) {
      return `${row[key[0]] + row[key[1]]}-tr`;
    }
    return `${row[0]}-tr`;
  };

  const getBGColor = (i) => {
    return i % 2 === 0 ? 'bg-white' : 'bg-neutral-100';
  };

  const isUrl = (value) => typeof value === 'object' && value?.type === 'url';
  const isPath = (value) => typeof value === 'object' && value?.type === 'path';

  return (
    <table className="table-data w-full min-w-max table-auto text-left text-black">
      <thead>
        <tr key="table-headers">
          {headers.map((header) => (
            <th
              key={header.attrName}
              className="border-b border-blue-gray-100 bg-blue-gray-50 p-2"
            >
              <div className={'table-header-content'}>{header.name}</div>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row, i) => (
          <tr
            key={createRowKey(row, rowKey)}
            style={{ backgroundColor: row.color ? row.color : '' }}
            className={`even:bg-blue-gray-50/50 ${getBGColor(i)}`}
          >
            {headers.map((header) => {
              if (header.attrName === 'clickAction') {
                return setAction(row);
              }
              if (isUrl(row[header.attrName])) {
                return (
                  <td
                    key={`${row[header.attrName]}-${header.attrName}`}
                    style={{ textAlign: 'center' }}
                    className="p-2"
                  >
                    <img
                      src={row[header.attrName].file}
                      alt={`Logo ${row.name}`}
                      style={{
                        maxWidth: '100px',
                        maxHeight: '100px',
                        width: 'auto',
                        height: 'auto',
                      }}
                    />
                  </td>
                );
              }
              if (isPath(row[header.attrName])) {
                return (
                  <td
                    key={`${row[header.attrName]}-${header.attrName}`}
                    style={{ textAlign: 'center' }}
                    className="p-2"
                  >
                    {row[header.attrName].file}
                  </td>
                );
              }
              if (
                header.attrName.includes('Tooltip') &&
                row[`${header.attrName}Need`]
              ) {
                return (
                  <td
                    key={`${createRowKey(row, rowKey)}-${header.attrName}`}
                    className="p-2 has-tooltip group"
                  >
                    <span>{row[header.attrName]}</span>
                    <span
                      className="absolute hidden group-hover:flex -mt-14 translate-y-full
                      w-48 px-2 py-1 bg-gray-700 rounded-lg text-center text-white text-sm"
                    >
                      {row[`${header.attrName}Text`]}
                    </span>
                  </td>
                );
              }
              return (
                <td
                  key={`${createRowKey(row, rowKey)}-${header.attrName}`}
                  className="p-2"
                >
                  {row[header.attrName]}
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default TableWithActions;
